import http from 'plugins/axios'

function query(params = {}) {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
}

export default {
  page(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/activity/page?${query(data)}`,
    })
  },
  detail(id) {
    return http.get({
      url: '/ta/admin/tenant/profitBonus/activity/detail',
      data: { id },
    })
  },
  add(data) {
    return http.post({
      url: '/ta/admin/tenant/profitBonus/activity/add',
      data,
    })
  },
  update(data) {
    return http.post({
      url: '/ta/admin/tenant/profitBonus/activity/update',
      data,
    })
  },
  status(id, status) {
    return http.post({
      url: `/ta/admin/tenant/profitBonus/activity/status?id=${encodeURIComponent(id)}&status=${encodeURIComponent(status)}`,
    })
  },
  quotaBeautifyConfig(id) {
    return http.get({ url: `/ta/admin/tenant/profitBonus/activity/quota-beautify/config?${query({ id })}` })
  },
  startNow(id) {
    return http.post({ url: `/ta/admin/tenant/profitBonus/activity/start-now?${query({ id })}` })
  },
  endNow(id) {
    return http.post({ url: `/ta/admin/tenant/profitBonus/activity/end-now?${query({ id })}` })
  },
  runNow(id) {
    return http.post({ url: `/ta/admin/tenant/profitBonus/activity/run-now?${query({ id })}` })
  },
  saveQuotaBeautifyConfig(data) {
    return http.post({ url: '/ta/admin/tenant/profitBonus/activity/quota-beautify/config', data })
  },
  quotaBeautifyRecords(data) {
    return http.get({ url: `/ta/admin/tenant/profitBonus/activity/quota-beautify/records/page?${query(data)}` })
  },
  userTypes() {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/type/options',
    })
  },
  symbols() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },
  vipEnums() {
    return http.get({
      url: '/ta/admin/tenant/vip/user/enums',
    })
  },
  taskPage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/task/page?${query(data)}`,
    })
  },
  taskTradeDataPage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/task/trade-data/page?${query(data)}`,
    })
  },
  taskDetail(id) {
    return http.get({
      url: '/ta/admin/tenant/profitBonus/task/detail',
      data: { id },
    })
  },
  taskAdd(data) {
    return http.post({
      url: '/ta/admin/tenant/profitBonus/task/add',
      data,
    })
  },
  taskUpdate(data) {
    return http.post({
      url: '/ta/admin/tenant/profitBonus/task/update',
      data,
    })
  },
  taskActivityOptions() {
    return http.get({
      url: '/ta/admin/tenant/profitBonus/task/activity/options',
    })
  },
  invitePage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/invite/page?${query(data)}`,
    })
  },
  inviteRecordsPage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/invite/records/page?${query(data)}`,
    })
  },
  rewardPage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/reward/page?${query(data)}`,
    })
  },
  rewardExport(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/reward/export?${query(data)}`,
      responseType: 'blob',
    })
  },
  rewardAuditPass(id) {
    return http.post({
      url: `/ta/admin/tenant/profitBonus/reward/audit/pass?id=${encodeURIComponent(id)}`,
    })
  },
  rewardAuditReject(id) {
    return http.post({
      url: `/ta/admin/tenant/profitBonus/reward/audit/reject?id=${encodeURIComponent(id)}`,
    })
  },
  rewardRegrant(id) {
    return http.post({
      url: `/ta/admin/tenant/profitBonus/reward/regrant?id=${encodeURIComponent(id)}`,
    })
  },
  statisticsPage(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/statistics/page?${query(data)}`,
    })
  },
  statisticsExport(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/statistics/export?${query(data)}`,
      responseType: 'blob',
    })
  },
  statisticsBonusLevels() {
    return http.get({
      url: '/ta/admin/tenant/profitBonus/statistics/bonus-levels',
    })
  },
  statisticsBaseRateRecords(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/statistics/base-rate-records/page?${query(data)}`,
    })
  },
  statisticsTaskRateRecords(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/statistics/task-rate-records/page?${query(data)}`,
    })
  },
  statisticsRewardRecords(data) {
    return http.get({
      url: `/ta/admin/tenant/profitBonus/statistics/reward-records/page?${query(data)}`,
    })
  },
}
